module.exports = __webpack_public_path__ + "static/media/intro-2.7369c598.jpg";